import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
    
          "Junior Web Developer",
          "Front end Developer",
          "Back end Developer",
          "UI/UX Designer",
          "Problem Solver ",

        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;